import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from 'DesignSystem/Buttons';
import { TrashIcon } from 'DesignSystem/Icons';

const DeleteSignatureButton = ({ deleteSignatureOnClick, hasLabel, type }) => (
  <PrimaryButton
    className="signature-preview-button btn btn-mini btn-danger remove-btn"
    onClick={(e) => { deleteSignatureOnClick(type, e); }}
    size="xs"
    variation="destructive"
  >
    <span className="my-documents-button delete-signature-trash-icon">
      <TrashIcon />{ hasLabel ? ' Delete' : '' }
    </span>
  </PrimaryButton>
);

DeleteSignatureButton.defaultProps = {
  hasLabel: true,
};

DeleteSignatureButton.propTypes = {
  deleteSignatureOnClick: PropTypes.func.isRequired,
  hasLabel: PropTypes.bool,
  type: PropTypes.string.isRequired,
};

export default DeleteSignatureButton;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/components/DeleteSignatureButton.jsx